<template><!-- svgo-optimised -->
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.71327 11.0904L3.5 14.0397V2.5H12.5V14.0397L8.28673 11.0904L8 10.8897L7.71327 11.0904Z" stroke="currentColor"/>
</svg>
</template>